var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h1',[_vm._v("17 December 2020 -- New Release!")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.firstPost)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }